<script setup lang="ts">
import useSiteSwitcher from "@/components/CMSComponents/SiteSwitcher/useSiteSwitcher.ts";
import SiteSwitcherFullpage from "@/cms/components/SiteSwitcher/SiteSwitcherFullpage.vue";

const {
  sites,
  goToSite,
  isInternal,
  searchSiteName,
  isInternalSiteSearchLoading,
} = useSiteSwitcher();

defineOptions({
  layout: "utility",
});
</script>

<template>
  <SiteSwitcherFullpage
    :sites
    :is-internal
    :is-internal-site-search-loading
    @go-to-site="goToSite"
    @search-site-name="searchSiteName"
  />
</template>
